import { BraxSelectOption } from 'design-system';

import { T } from '../utils/i18n';

export type PaymentMethod = 'bank_slip' | 'credit_card';

const paymentMethod: BraxSelectOption<PaymentMethod>[] = [{
    value: 'bank_slip',
    title: <T label="Boleto ou Pix" />,
    icon: 'invoice'
}, {
    title: <T label="Cartão de Crédito" />,
    value: 'credit_card',
    icon: 'card'
}];

export default paymentMethod;
